module.exports = __webpack_public_path__ + "static/media/logo_fb.f8b97394.svg";